// Independent of auth/HTTP/DB imports so logout can drain admitted local writes
// without waiting for requests or introducing an auth-store import cycle.
let writes: Promise<unknown> = Promise.resolve();

export function commitManagerCacheWrite(
  assertCurrent: () => void,
  write: () => Promise<void>
): Promise<void> {
  assertCurrent();
  const pending = writes.then(async () => {
    assertCurrent();
    await write();
    assertCurrent();
  });
  writes = pending.catch(() => undefined);
  return pending;
}

export async function drainManagerCacheWrites(): Promise<void> {
  await writes;
}
